//import Administration from './Administration/Administration'
import '../styles/Center.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles//Table.css';
import { ToolsPanel } from './ToolsPanel';
import Administration from './Administration/Administration';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { provideGlobalGridOptions } from 'ag-grid-community';
import Statisctics from './Statistics/Statisctics';
import context from './Administration/context/shared';
import { observer } from 'mobx-react-lite';
import HardwareCommands from './Statistics/HardwareCommands';
import ServiceManagement from './ServiceManagement/ServiceManagement';

// Mark all grids as using legacy themes
provideGlobalGridOptions({
    theme: "legacy",
});

const Center = observer(() => {
    const { tabIndex, setTabIndex } = context;

    const tabs = [
        {
            title: "Администрирование",
            render: () => <Administration />
        },
        {
            title: "Статистика",
            render: (isActive: boolean) => <Statisctics tabIsActive={isActive} />
        },
        {
            title: "Аппаратные команды",
            render: (isActive: boolean) => <HardwareCommands tabIsActive={isActive} />
        },
        {
            title: "Управление",
            render: (isActive: boolean) => <ServiceManagement tabIsActive={isActive} />
        },
    ].filter(Boolean);

    return (
        <div id="body">
            <Tabs forceRenderTabPanel={true} className="modes" selectedIndex={tabIndex} onSelect={setTabIndex}>
                <TabList>
                    {tabs.map((tab, idx) => (
                        <Tab key={idx} title={tab.title}>
                            <label>{tab.title}</label>
                        </Tab>
                    ))}
                </TabList>
                <div id="middleContainer">
                    {tabs.map((tab, idx) => (
                        <TabPanel key={tab.title} tabIndex={idx} forceRender={true}>
                            {tab.render(tabIndex === idx)}
                        </TabPanel>
                    ))}
                </div>  
            </Tabs>
            <ToolsPanel />
        </div>
    );   
})
export default Center;
